import styled from 'styled-components';

export default styled.div``;

export const SubmitWrapper = styled.div`
  margin-top: 1.5rem;
`;
